module.exports = __webpack_public_path__ + "img/resolve.a3bc241d.png";